import React, { useState, useEffect } from 'react';
import { Navigation } from './Navigation';
import { Hamburger } from './Hamburger';
import { StoreBadges } from './StoreBadges';
import './HeaderNavigation.scss';

const navLinks = [
  { text: 'Home', to: '/', className: 'hamburger-link' },
  { text: 'I am a restaurant', to: '/restaurants', className: 'button secondary' },
  { text: 'Blog', to: '/blog', className: 'button white outline' },
];

const MobileNavFooter = () => (
  <div className="mobile-nav-footer">
    <StoreBadges />
  </div>
);

export const HeaderNavigation = () => {
  const [showNav, setShowNav] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [bodyLocked, setBodyLock] = useState(false);

  const toggleNav = event => {
    event.preventDefault();
    setShowNav(!showNav);
  };

  const handleEscKey = event => {
    if (event.keyCode === 27) {
      document.body.classList.remove('nav-open');
      setShowNav(false);
    }
  };

  const handleModalBackgroundClick = event => {
    if (!event || !event.target) return null;
    const { className } = event.target;
    if (className === 'nav-open') {
      return toggleNav();
    }
    return null;
  };

  const lockBody = () => {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    setScrollTop(scrollPosition);
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add('nav-open');
    setBodyLock(true);
  };

  const unlockBody = () => {
    document.body.classList.remove('nav-open');
    document.body.style.top = '0px';
    window.scrollTo(0, scrollTop);
    setScrollTop(0);
    setBodyLock(false);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscKey, false);
    document.addEventListener('click', handleModalBackgroundClick, false);
    return () => {
      document.removeEventListener('keydown', handleEscKey, false);
      document.removeEventListener('click', handleModalBackgroundClick, false);
      unlockBody();
    };
  }, []);

  useEffect(() => {
    if (showNav && !bodyLocked) lockBody();
    if (!showNav && bodyLocked) unlockBody();
  }, [showNav]);

  return (
    <>
      <Navigation
        links={navLinks}
        classNamePrefix="header"
        extraClassNames={showNav ? 'active' : 'inactive'}
        MobileNavFooter={MobileNavFooter}
      />
      <Hamburger active={showNav} onClick={toggleNav} />
    </>
  );
};
